import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { KbMiniCartComponent } from './kb-mini-cart.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MiniCartPopUpComponent } from './mini-cart-pop-up/mini-cart-pop-up.component';



@NgModule({
  declarations: [KbMiniCartComponent, MiniCartPopUpComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MiniCartComponent: {
          component: KbMiniCartComponent,
        },
      }
    } as CmsConfig)
  ]
})
export class MiniCartModule { }
